import { Container, Stack } from '@mui/material';
import AuthenticatingUser from '../views/AuthenticatingUser';
import { useUserManagement } from '../features/UserManagement/components/UserManagementContext';
import AlmaHeader from '../../src/components/Header/AlmaHeader';
import { useDocumentContext } from './DocumentContext';
import AccessDenied from '../views/AccessDenied';
import { useFeatureFlag } from '../../src/common/components/FeatureFlag';
import ErrorView from '../../src/components/ErrorViews/ErrorView';
import ReadingViewPage from './ReadingViewPage';

function Loading() {
  return (
    <Stack
      sx={{
        marginTop: 12,
        alignItems: 'center',
        width: '100%',
      }}
    >
      <AuthenticatingUser />
    </Stack>
  );
}

function NonPageContent({
  isSuspended,
  accessDenied,
  showError,
}: Readonly<{
  isSuspended: boolean;
  accessDenied: boolean;
  showError: boolean;
}>) {
  return (
    <>
      <AlmaHeader />
      <Container maxWidth='md' sx={{ marginTop: 12 }}>
        {isSuspended && <Loading />}
        {!isSuspended && accessDenied && <AccessDenied />}
        {!isSuspended && showError && <ErrorView apiError={null} />}
      </Container>
    </>
  );
}

export default function Reader() {
  const { identity } = useUserManagement();
  const { state: documentState } = useDocumentContext();

  const isSuspended = identity.loading || documentState === 'loading';
  const hasReadingViewFlag = useFeatureFlag('readingView', identity.authInfo);
  const accessDenied = !hasReadingViewFlag || documentState === 'access-denied';
  const showError = !isSuspended && documentState === 'error';
  const shouldShowPage =
    !isSuspended && hasReadingViewFlag && documentState === 'ready';

  return (
    <Stack sx={{ minHeight: '100vh', height: '100%' }}>
      {shouldShowPage ? (
        <ReadingViewPage />
      ) : (
        <NonPageContent
          isSuspended={isSuspended}
          accessDenied={accessDenied}
          showError={showError}
        />
      )}
    </Stack>
  );
}
